var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 687,
    height: 110,
    viewBox: "0 0 687 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.1498 91.1101H52.7998V109.75H63.1498V91.1101Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145.98 91.1101H135.63V109.75H145.98V91.1101Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M228.81 91.1101H218.46V109.75H228.81V91.1101Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M194.65 0H165.66V109.75H194.65V91.11H198.79V18.64H194.65V0ZM190.51 72.48H186.37V91.12H173.95V18.64H186.37V37.28H190.51V72.48Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M115.96 18.64V0H86.9701V18.64H82.8301V91.11H86.9701V109.75H115.96V91.11H91.1101V64.19H111.82V45.56H91.1101V18.64H115.96Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28 91.11V0H0V91.11H4.14V109.75H33.13V91.11H8.28Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M529.069 0H495.939V18.64H508.359V109.75H516.649V18.64H529.069V0Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M647.099 18.64V0H618.109V18.64H628.469V91.11H618.109V109.75H647.099V91.11H636.749V18.64H647.099Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M490.76 91.11V64.19H486.62V45.56H465.91V18.64H482.48V37.27H490.76V18.64H486.62V0H461.77V18.64H457.63V45.56H461.77V64.19H482.48V91.11H465.91V72.48H457.63V91.11H461.77V109.75H486.62V91.11H490.76Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M686.44 91.11V18.64H682.3V0H657.45V18.64H653.31V91.11H657.45V109.75H682.3V91.11H686.44ZM678.16 72.47H674.02V91.11H665.74V72.47H661.6V37.27H665.74V18.64H674.02V37.28H678.16V72.48V72.47Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M607.76 91.11H611.9V18.64H607.76V0H578.77V109.75H607.76V91.11ZM603.62 72.47H599.479V91.11H587.06V18.64H599.479V37.28H603.62V72.48V72.47Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M535.28 91.11H539.42V109.75H564.27V91.11H568.41V0H560.13V91.11H543.56V0H535.28V91.11Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoText);
export default __webpack_public_path__ + "static/media/logo-text.a37e112cd04e5613316c314c2f0e3c1a.svg";
export { ForwardRef as ReactComponent };